import { useState, useEffect } from 'react';
import './admin.css';

import { auth, db } from '../../firebaseConnection';
import { signOut } from 'firebase/auth';
import {
  addDoc,
  collection,
  onSnapshot,
  query,
  orderBy,
  where,
  doc,
  deleteDoc,
  updateDoc
} from 'firebase/firestore';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Admin() {
  const [tarefaInput, setTarefaInput] = useState('');
  const [user, setUser] = useState({});
  const [tarefas, setTarefas] = useState([]);
  const [edit, setEdit] = useState({})

  useEffect(() => {
    const userDetail = localStorage.getItem('@webtasksuser');
    const data = JSON.parse(userDetail);
    setUser(data);

    let unsubscribe;

    async function loadTarefa() {
      if (data) {
        const tarefaRef = collection(db, 'tasks');
        const q = query(
          tarefaRef,
          orderBy('created', 'desc'),
          where('userUid', '==', data?.uid)
        );

        unsubscribe = onSnapshot(q, (snapshot) => {
          const list = [];

          snapshot.forEach((doc) => {
            list.push({
              id: doc.id,
              tarefa: doc.data().tarefa,
              userUid: doc.data().userUid,
            });
          });

          setTarefas(list);
        });
      }
    }

    loadTarefa();

    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  async function handleRegister(e) {
    e.preventDefault();

    if (tarefaInput === '') {
      toast.warn('Digite uma tarefa!');
      return;
    }

    if(edit?.id){
      handleUpdateTask();
      return;
    }

    await addDoc(collection(db, 'tasks'), {
      tarefa: tarefaInput,
      created: new Date(),
      userUid: user?.uid,
    })
      .then(() => {
        toast.success('Tarefa registrada com sucesso!');
        setTarefaInput('');
      })
      .catch((error) => {
        toast.error('Erro ao registrar tarefa: ' + error);
      });
  }

  async function handleUpdateTask() {
    const docRef = doc(db, 'tasks', edit?.id)
    await updateDoc(docRef, {
      tarefa: tarefaInput
    })
    .then(()=>{
      toast.success("Tarefa editada com sucesso")
    })
    .catch((error)=> {
      console.log("Error ao editar tarefa" + error)
      toast.error('Erro ao registrar tarefa: ' + error);
    })

    setTarefaInput('')
    setEdit({})

  }

  async function handleLogout() {
    await signOut(auth);
  }

  function handleDelete(task) {
    const toastId = toast.info(
      <div>
        <p>
          Deseja realmente concluir a tarefa: <strong>{task.tarefa}</strong>?
        </p>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
          <button
            onClick={async () => {
              try {
                await deleteDoc(doc(db, 'tasks', task.id));
                toast.dismiss(toastId);
                
                toast.success('Tarefa concluída com sucesso!', {
                  autoClose: 2000,
                });
              } catch (error) {
                toast.error('Erro ao deletar tarefa.');
              }
            }}
            style={{
              marginRight: 8,
              backgroundColor: '#e74c3c',
              color: '#fff',
              border: 'none',
              padding: '5px 10px',
              cursor: 'pointer',
            }}
          >
            Confirmar
          </button>
          <button
            onClick={() => toast.dismiss()}
            style={{
              backgroundColor: '#ccc',
              border: 'none',
              padding: '5px 10px',
              cursor: 'pointer',
            }}
          >
            Cancelar
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        closeButton: false,
      }
    );
  }

  async function handleEditTask(task) {
    setTarefaInput(task.tarefa)
    setEdit(task)
  }

  return (
    <div className='admin-container'>
      <h1>Minhas Tarefas</h1>

      <form className='form' onSubmit={handleRegister}>
        <textarea
          className='text-area'
          placeholder='Digite sua tarefa...'
          value={tarefaInput}
          onChange={(e) => setTarefaInput(e.target.value)}
        />
        {Object.keys(edit).length > 0 ? (
          <button className='btn-register' 
            style={{backgroundColor: "#6add39"}}
            type='submit'>
            Atualizar tarefa
          </button>
        ) : <button className='btn-register' type='submit'>
            Registrar tarefa
          </button>
        } 
      </form>

      {tarefas.map((task) => (
        <article key={task.id} className='list'>
          <p>{task.tarefa}</p>
          <div>
            <button onClick={() => handleEditTask(task)}>
              Editar
            </button>
            <button className='btn-delete' onClick={() => handleDelete(task)}>
              Concluir
            </button>
          </div>
        </article>
      ))}

      <button onClick={handleLogout} className='btn-logout'>
        Sair
      </button>

      {/* Toastify Container */}
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
